// extracted by mini-css-extract-plugin
export default {"imagesWrapper":"lG-z"};